<template>
  <ContentLoader :width="310" :height="76" :speed="1" :class="$style.content">
    <rect x="81" y="20" rx="0" ry="0" width="150" height="15" />
    <rect x="81" y="46" rx="0" ry="0" width="190" height="12" />
    <circle cx="42" cy="42" r="30" />
  </ContentLoader>
</template>

<script>
import { ContentLoader } from 'vue-content-loader'

export default {
  name: 'sidebar-loader',
  components: {
    ContentLoader
  }
}
</script>

<style module lang="scss">
.content {
  height: 76px;
}
</style>
